import React from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';
import ModeSelection from '../components/ModeSelection';
import Layout from '../components/Layout';
import { getPersonalities } from '../data/personalities';
import { generateCharacter } from '../utils/characterGenerator';

const VALID_GENDERS = ['male', 'female'];

const ModePage = () => {
  const { isKeyValid, trialMode, trialBlock } = useApiKey();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const gender = searchParams.get('gender');

  const trialActive = trialMode && trialBlock !== 'trial_exhausted' && trialBlock !== 'owner_out_of_credits';
  const canPractice = isKeyValid || trialActive;

  // Gate: can't practice, or arrived without a valid gender — bounce to the
  // right earlier step.
  if (!canPractice) return <Navigate to="/" replace />;
  if (!VALID_GENDERS.includes(gender)) return <Navigate to="/" replace />;

  // Quick Practice and Date in Eight don't let you choose who you'll face —
  // grab a random personality and jump straight into the chat.
  const pickRandomPersonality = () => {
    const personalities = getPersonalities(gender);
    return personalities[Math.floor(Math.random() * personalities.length)];
  };

  const startChat = (personality, extra) => {
    const character = generateCharacter(personality, gender);
    navigate('/chat', { state: { personality, character, ...extra } });
  };

  return (
    <Layout>
      <ModeSelection
        gender={gender}
        onFreePractice={() => navigate(`/personality?gender=${gender}`)}
        onQuickPractice={() => startChat(pickRandomPersonality(), { freeMode: false })}
        onGameMode={() => navigate(`/date-in-eight?gender=${gender}`)}
        onChangeGender={() => navigate('/')}
      />
    </Layout>
  );
};

export default ModePage;
